import React, { useState } from "react";
import Drawer from "../SideDrawer/SideDrawer";
import CloseIcon from "../../assets/svg/close-icon";
import LightModeIcon from "../../assets/svg/light-mode-icon";
import CalendarIcon from "../../assets/svg/calendar-icon";
import FontSizeIcon from "../../assets/svg/font-size-icon";
// import LanguageTwoIcon from "../../assets/svg/language-two-icon";
// import NetworkIcon from "../../assets/svg/network-icon";
// import DoNotDisturbIcon from "../../assets/svg/do-not-disturb-icon";
import ChevronRightIcon from "../../assets/svg/chevron-right-icon";
import Appearance from "./components/Appearance";
import CircularArrowBackIcon from "../../assets/svg/circular-arrow-back-icon";
import DateAndTimeFormat from "./components/DateAndTimeFormat";
import FontSize from "./components/FontSize";

const accessibilityOptions = [
  {
    id: "appearance",
    label: "Appearance",
    icon: LightModeIcon,
  },
  {
    id: "date-time-format",
    label: "Date & Time Format",
    icon: CalendarIcon,
  },
  {
    id: "font-size",
    label: "Font Size",
    icon: FontSizeIcon,
  },
  // {
  //   id: "language",
  //   label: "Language",
  //   icon: LanguageTwoIcon,
  // },
  // {
  //   id: "timezone",
  //   label: "Timezone",
  //   icon: NetworkIcon,
  // },
  // {
  //   id: "do-not-disturb",
  //   label: "Do Not Disturb",
  //   icon: DoNotDisturbIcon,
  // },
];

const accessibilityOptionsIds = [
  "appearance",
  "date-time-format",
  "font-size",
  "language",
  "timezone",
];

const accessibilityOptionsMap = accessibilityOptions.reduce((acc, option) => {
  acc[option.id] = option.label;
  return acc;
}, {} as Record<string, string>);

const renderSelectedComponent = (selectedOption: string) => {
  switch (selectedOption) {
    case "appearance":
      return <Appearance />;
    case "date-time-format":
      return <DateAndTimeFormat />;
    case "font-size":
      return <FontSize />;
    default:
      return null;
  }
};

const AccessibilityDrawer = ({
  openDrawer,
  setOpenDrawer,
  size = "300px",
}: {
  openDrawer: boolean;
  setOpenDrawer: (open: boolean) => void;
  size: string;
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const handleSelectOption = (optionId: string) => {
    setSelectedOption(optionId);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setSelectedOption(null);
  };

  const handleBackClick = () => {
    setSelectedOption(null);
  };

  const getSelectedOptionLabel = () => {
    return selectedOption && accessibilityOptionsIds.includes(selectedOption)
      ? accessibilityOptionsMap[selectedOption] || "Accessibility Settings"
      : "Accessibility Settings";
  };

  return (
    <Drawer
      open={openDrawer}
      onClose={handleCloseDrawer}
      direction="right"
      size={size}
      overlayColor="rgba(0,0,0,0.7)"
      duration={300}
      closeOnOverlayClick={true}
      closeOnEscape={true}
      drawerContainerClassName="rounded-l-[8px]"
    >
      <div>
        <div className="flex items-center justify-between px-[18px] py-[12px] border-b border-border-gray dark:border-border-gray-dk">
          <div className="flex items-center gap-[6px]">
            {selectedOption && (
              <button
                onClick={handleBackClick}
                className="cursor-pointer"
                aria-label="Go back"
              >
                <CircularArrowBackIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
              </button>
            )}
            <h2 className="text-heading-text dark:text-heading-text-dk font-semibold text-md">
              {getSelectedOptionLabel()}
            </h2>
          </div>
          <button
            className={`w-[16px] h-[16px] bg-tag-gray dark:bg-tag-gray-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200 hover:scale-110`}
            aria-label="Close modal"
            onClick={handleCloseDrawer}
          >
            <CloseIcon className="w-[6px] h-[6px] text-verba-indigo dark:text-verba-indigo-dk" />
          </button>
        </div>
        {selectedOption && accessibilityOptionsIds.includes(selectedOption)
          ? renderSelectedComponent(selectedOption)
          : accessibilityOptions.map((option) => {
              const Icon = option.icon;
              return (
                <div
                  key={option.id}
                  onClick={() => handleSelectOption(option.id)}
                  className="cursor-pointer w-full hover:bg-hover-effect dark:hover:bg-hover-effect-dk flex items-center justify-between px-[18px] py-[12px] border-b border-border-gray dark:border-border-gray-dk"
                >
                  <div className="flex items-center gap-[4px]">
                    <Icon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
                    <p className="text-verba-indigo dark:text-verba-indigo-dk font-medium text-md">
                      {option.label}
                    </p>
                  </div>
                  <button>
                    <ChevronRightIcon className="w-[18px] h-[18px] text-verba-indigo dark:text-verba-indigo-dk" />
                  </button>
                </div>
              );
            })}
      </div>
    </Drawer>
  );
};

export default AccessibilityDrawer;
